import { postPayoutAll4Pay, getOperationTypesAll4Pay } from '@/utils/api';
import Vue from 'vue';
import { helpers } from 'vuelidate/lib/validators';
import Vuex from 'vuex';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const state = {
  payoutStatus: {
    initialize: false,
    loading: false,
    success: false,
    error: false,
  },
  helpers: {
    operationTypes: [],
  },
};

const mutations = {
  setPayoutStatus(state, row) {
    state.payoutStatus = row;
  },
  setHelpers(state, helpers) {
    state.helpers = helpers;
  },
};
const getters = {};
const actions = {
  tryGetHelpers({ commit }) {
    commit('setPayoutStatus', { initialize: false });
    getOperationTypesAll4Pay()
      .then(r => {
        if (r.data.IsSuccess) {
          commit('setHelpers', r.data.Data);
        }
      })
      .finally(() => {
        commit('setPayoutStatus', { initialize: false });
      });
  },
  tryPayout({ rootState, commit }, payload) {
    payload = {
      ...payload,
      PayoutMethod: rootState.payoutStore.selectedPayoutMethod.pk_mstpayout_method,
      PayoutAmount: rootState.payoutStore.amount,
    };
    commit('setPayoutStatus', { loading: true });
    postPayoutAll4Pay(payload)
      .then(r => {
        if (r.data.IsSuccess) {
          if (r.data.Data.status && r.data.Data.status === 'OK') {
            if (r.data.Data.error_code === 'NEW_PAYOUT') {
              commit('setPayoutStatus', {
                success: i18n.t('Exceptions.eTef.' + r.data.Data.error_code),
              });
              return;
            }

            commit('setPayoutStatus', {
              success: i18n.t('Exceptions.' + r.data.Data.error_code) || r.data.Data.message,
            });
          } else {
            commit('setPayoutStatus', {
              error: r.data.Data.error_code || r.data.Data.message,
            });
          }
        } else {
          commit('setPayoutStatus', { error: 'Payout.All4Pay.Error' });
        }
      })
      .catch(() => {
        commit('setPayoutStatus', { error: 'Payout.All4Pay.Error' });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
